import { render, staticRenderFns } from "./change-picture.vue?vue&type=template&id=60c7d546&scoped=true"
import script from "./change-picture.vue?vue&type=script&lang=js"
export * from "./change-picture.vue?vue&type=script&lang=js"
import style0 from "./change-picture.vue?vue&type=style&index=0&id=60c7d546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c7d546",
  null
  
)

export default component.exports